import {
  Box,
  Button,
  Chip,
  TextField,
  IconButton,
  LinearProgress,
  Alert,
} from "@mui/material";
import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
import ReactQuill, { Quill } from "react-quill-new";
import QuillTableBetter from "quill-table-better";
import "react-quill-new/dist/quill.snow.css";
import "quill-table-better/dist/quill-table-better.css";
import { BASE_URL, TARGET_TYPE } from "../../constants";
import AddchartIcon from "@mui/icons-material/Addchart";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CategoryIcon from "@mui/icons-material/Category";
import DeleteIcon from "@mui/icons-material/Delete";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import Log from "../logDialog/Log";

Quill.register({ "modules/table-better": QuillTableBetter }, true);
const Radiology = ({
  test,
  investigation,
  setSelectedRadiologyInvestigation,
  noOfInvestigations,
  setInvestigations,
  setSelectedTest,
  setOpenModal,
}) => {
  const user = useRecoilValue(authState);
  const [loading, setLoading] = useState(false);
  const quillRefs = useRef([]);
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: 1 }, { header: 2 }], // custom button values
          ["bold", "italic", "underline", "strike"], // toggled buttons
          ["link", "image"],
          [{ list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ direction: "rtl" }], // text direction
          [{ size: ["small", false, "large", "huge"] }], // custom dropdown
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],
          // ['tableUI']
          ["table-better"], // Add table tool
        ],
      },
      table: false,
      "table-better": {
        language: "en_US",
        menus: [
          "column",
          "row",
          "merge",
          "table",
          "cell",
          "wrap",
          "copy",
          "delete",
        ],
        toolbarTable: true,
      },
      keyboard: {
        bindings: QuillTableBetter.keyboardBindings,
      },
    }),
    []
  );
  // ✅ Load content when testContent changes DO NOT depend on whole item
  useLayoutEffect(() => {
    investigation?.forEach((inv, i) => {
      const quill = quillRefs.current[i];
      if (!quill) return;
      if (!inv?.testContent) return;

      const editor = quill.getEditor();
      const html = inv.testContent.trim();

      const currentHTML = editor.root.innerHTML.trim();
      if (currentHTML === html) return; // Prevent infinite loop

      // ✅ This is the key part (same as your working single-case logic)
      const delta = editor.clipboard.convert({ html });

      editor.setContents([], Quill.sources.SILENT);

      // ✅ Don't use setContents; use updateContents to respect table structure
      editor.updateContents(delta, Quill.sources.USER);

      // ✅ Restore cursor safely
      const range = editor.getSelection();
      editor.setSelection(
        delta.length() - (range?.length || 0),
        Quill.sources.SILENT
      );

      editor.scrollSelectionIntoView();
    });
  }, [investigation]);

  const handleAddMethod = () => {
    setSelectedRadiologyInvestigation([
      ...investigation,
      { formatName: "", testContent: "" },
    ]);
  };

  const handleChange = (index, value) => {
    const updatedInvestigations = [...investigation];
    updatedInvestigations[index].testContent = value;
    setSelectedRadiologyInvestigation(updatedInvestigations);
  };

  const handleDeleteMethod = (index) => {
    if (investigation.length === 1) return;
    const updatedInvestigations = investigation.filter((_, i) => i !== index);
    setSelectedRadiologyInvestigation(updatedInvestigations);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${BASE_URL}api/user/radiology/create-radiology-investigation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            testId: test._id,
            investigations: investigation,
          }),
        }
      );

      const result = await response.json();
      if (result.success) {
        alert("Investigations submitted successfully!");
        setInvestigations(null);
        setSelectedTest(null);
      } else {
        alert("Failed to submit investigations.");
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      alert("An unexpected error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const updateInvestigation = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${BASE_URL}api/user/radiology/update-radiology-investigation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            testId: test._id,
            investigations: investigation,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error:", errorData);
        alert(
          `Failed to submit investigation: ${
            errorData.error || "Unknown error occurred."
          }`
        );
        return;
      }

      const result = await response.json();

      if (result.success) {
        console.log(result.message);
        alert("Investigation updated successfully!");
      } else {
        console.error("Updation failed:", result.error || result.message);
        alert("Failed to Update investigation.");
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      alert("An unexpected error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const toolbarOptions = [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline", "strike"],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["blockquote"],
    [{ script: "sub" }, { script: "super" }],
    [{ size: ["small", "medium", "large", "huge"] }],
  ];

  const [openLogDialog, setOpenLogDialog] = useState(false);
  const [headerLogs, setHeaderLogs] = useState(null);
  const handleViewLog = async (type) => {
    setOpenLogDialog(true);
    let targetType;
    if (type === "header") targetType = TARGET_TYPE.testHeader;
    else if (type === "radiologyInvestigation")
      targetType = TARGET_TYPE.radiologyInvestigation;

    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-logs?id=${test._id}&targetType=${targetType}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const headers = await response.json();
      setHeaderLogs(headers.logs);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      // setLoading(false);
    }
  };
  const handleCloseLog = () => {
    setOpenLogDialog(false);
  };

  return (
    <div>
      <Chip avatar={<AddchartIcon />} label={test && test.testName} />
      <Chip
        avatar={<CategoryIcon />}
        label={test && test.testCat}
        sx={{ marginX: 1 }}
      />
      <Chip avatar={<CurrencyRupeeIcon />} label={test && test.testPrice} />
      {user?._doc?.permissions?.testHeaderManagement?.edit && (
        <Button onClick={() => setOpenModal(true)}>Edit Header</Button>
      )}
      {user?._doc?.role === "Admin" && (
        <Box>
          <FormatAlignLeftIcon sx={{ color: "orange", fontSize: "1rem" }} />
          <span
            style={{
              fontSize: "0.75rem",
              cursor: "pointer",
              color: "orange",
            }}
            onClick={() => handleViewLog("header")}
          >
            view test header logs{" "}
          </span>
          <FormatAlignLeftIcon sx={{ color: "orange", fontSize: "1rem" }} />
          <span
            style={{
              fontSize: "0.75rem",
              cursor: "pointer",
              color: "orange",
            }}
            onClick={() => handleViewLog("radiologyInvestigation")}
          >
            view investigation logs
          </span>
        </Box>
      )}
      <Log
        openLogDialog={openLogDialog}
        handleCloseLog={handleCloseLog}
        logs={headerLogs}
      />
      <Box sx={{ mt: 2 }}>
        {investigation?.map((item, index) => (
          <Box
            key={index}
            sx={{
              mb: 2,
              display: "flex",
              alignItems: "center",
              position: "relative",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <TextField
                id="filled-basic"
                label="Format Name"
                variant="filled"
                fullWidth
                size="small"
                value={item.formatName}
                onChange={(e) => {
                  const updatedInvestigations = [...investigation];
                  updatedInvestigations[index].formatName = e.target.value;
                  setSelectedRadiologyInvestigation(updatedInvestigations);
                }}
                sx={{ backgroundColor: "#bbffdf" }}
              />
              {loading && (
                <LinearProgress
                  color="success"
                  sx={{ height: 2, width: "100%" }}
                />
              )}
              <ReactQuill
                ref={(el) => (quillRefs.current[index] = el)} // <--- IMPORTANT
                theme="snow"
                modules={modules}
                placeholder="Define the test structure..."
                onChange={(value) => handleChange(index, value)}
              />
              {/* <ReactQuill
                value={item.testContent}
                onChange={(value) => handleChange(index, value)}
                placeholder="Define the test structure..."
                modules={{
                  toolbar: toolbarOptions,
                }}
              /> */}
            </Box>
            {investigation.length === 1 ? (
              ""
            ) : (
              <IconButton
                onClick={() => handleDeleteMethod(index)}
                color="error"
                sx={{ ml: 2, position: "absolute", left: "90%", top: "4%" }}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </Box>
        ))}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
        <Button onClick={handleAddMethod} variant="outlined">
          Add Format
        </Button>
        {noOfInvestigations === 0 ? (
          user?._doc?.permissions?.investigationManagement?.create ? (
            <Button
              onClick={handleSubmit}
              variant="contained"
              disabled={loading}
            >
              {`${!loading ? "Submit" : "Submitting"}`}
            </Button>
          ) : (
            <Alert severity="error">You have no permission to create</Alert>
          )
        ) : user?._doc?.permissions?.investigationManagement?.edit ? (
          <Button
            onClick={updateInvestigation}
            variant="contained"
            color="warning"
            disabled={loading}
          >
            {`${!loading ? "Update" : "Updating"}`}
          </Button>
        ) : (
          <Alert severity="error">You have no permission to update</Alert>
        )}
      </Box>
    </div>
  );
};

export default Radiology;
